const buttonFilled: object = {
  white: {
    backgroud: "bg-white",
    color: "text-blue-gray-900",
    shadow: "shadow-md shadow-blue-gray-500/10",
    hover: "hover:shadow-lg hover:shadow-blue-gray-500/20",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  "blue-gray": {
    backgroud: "bg-blue-gray-500",
    color: "text-white",
    shadow: "shadow-md shadow-blue-gray-500/20",
    hover: "hover:shadow-lg hover:shadow-blue-gray-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  gray: {
    backgroud: "bg-gray-900",
    color: "text-white",
    shadow: "shadow-md shadow-gray-900/10",
    hover: "hover:shadow-lg hover:shadow-gray-900/20",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  brown: {
    backgroud: "bg-brown-500",
    color: "text-white",
    shadow: "shadow-md shadow-brown-500/20",
    hover: "hover:shadow-lg hover:shadow-brown-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  "deep-orange": {
    backgroud: "bg-deep-orange-500",
    color: "text-white",
    shadow: "shadow-md shadow-deep-orange-500/20",
    hover: "hover:shadow-lg hover:shadow-deep-orange-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  orange: {
    backgroud: "bg-orange-500",
    color: "text-white",
    shadow: "shadow-md shadow-orange-500/20",
    hover: "hover:shadow-lg hover:shadow-orange-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  amber: {
    backgroud: "bg-amber-500",
    color: "text-black",
    shadow: "shadow-md shadow-amber-500/20",
    hover: "hover:shadow-lg hover:shadow-amber-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  yellow: {
    backgroud: "bg-yellow-500",
    color: "text-black",
    shadow: "shadow-md shadow-yellow-500/20",
    hover: "hover:shadow-lg hover:shadow-yellow-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  lime: {
    backgroud: "bg-lime-500",
    color: "text-black",
    shadow: "shadow-md shadow-lime-500/20",
    hover: "hover:shadow-lg hover:shadow-lime-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  "light-green": {
    backgroud: "bg-light-green-500",
    color: "text-white",
    shadow: "shadow-md shadow-light-green-500/20",
    hover: "hover:shadow-lg hover:shadow-light-green-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  green: {
    backgroud: "bg-green-500",
    color: "text-white",
    shadow: "shadow-md shadow-green-500/20",
    hover: "hover:shadow-lg hover:shadow-green-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  teal: {
    backgroud: "bg-teal-500",
    color: "text-white",
    shadow: "shadow-md shadow-teal-500/20",
    hover: "hover:shadow-lg hover:shadow-teal-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  cyan: {
    backgroud: "bg-cyan-500",
    color: "text-white",
    shadow: "shadow-md shadow-cyan-500/20",
    hover: "hover:shadow-lg hover:shadow-cyan-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  "light-blue": {
    backgroud: "bg-light-blue-500",
    color: "text-white",
    shadow: "shadow-md shadow-light-blue-500/20",
    hover: "hover:shadow-lg hover:shadow-light-blue-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  blue: {
    backgroud: "bg-blue-500",
    color: "text-white",
    shadow: "shadow-md shadow-blue-500/20",
    hover: "hover:shadow-lg hover:shadow-blue-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  indigo: {
    backgroud: "bg-indigo-500",
    color: "text-white",
    shadow: "shadow-md shadow-indigo-500/20",
    hover: "hover:shadow-lg hover:shadow-indigo-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  "deep-purple": {
    backgroud: "bg-deep-purple-500",
    color: "text-white",
    shadow: "shadow-md shadow-deep-purple-500/20",
    hover: "hover:shadow-lg hover:shadow-deep-purple-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  purple: {
    backgroud: "bg-purple-500",
    color: "text-white",
    shadow: "shadow-md shadow-purple-500/20",
    hover: "hover:shadow-lg hover:shadow-purple-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  pink: {
    backgroud: "bg-pink-500",
    color: "text-white",
    shadow: "shadow-md shadow-pink-500/20",
    hover: "hover:shadow-lg hover:shadow-pink-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
  red: {
    backgroud: "bg-red-500",
    color: "text-white",
    shadow: "shadow-md shadow-red-500/20",
    hover: "hover:shadow-lg hover:shadow-red-500/40",
    focus: "focus:opacity-[0.85] focus:shadow-none",
    active: "active:opacity-[0.85] active:shadow-none",
  },
};

export default buttonFilled;
